import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  padding: 0 15px;

  @media (min-width: 900px) {
    display: none;
  }
`;

const StyledTab = styled.div`
  align-items: center;
  cursor: pointer;
  display: flex;
  height: 45px;
  justify-content: center;
  text-decoration: ${({ underline }) => (underline ? 'underline' : 'none')};
  width: 50%;
`;

class Tab extends React.Component {
  static propTypes = {
    label: PropTypes.string.isRequired,
    setView: PropTypes.func.isRequired,
    underline: PropTypes.bool.isRequired,
    view: PropTypes.string.isRequired,
  };

  setView = () => {
    const { view, setView } = this.props;
    setView(view);
  };

  render = () => {
    const { label, underline } = this.props;
    return (
      <StyledTab onClick={this.setView} underline={underline}>
        {label}
      </StyledTab>
    );
  };
}

const Selector = ({ currentView, setView }) => (
  <Container>
    <Tab view="map" underline={currentView === 'map'} label="MAP VIEW" setView={setView} />
    <Tab view="list" underline={currentView === 'list'} label="LIST VIEW" setView={setView} />
  </Container>
);

Selector.propTypes = {
  currentView: PropTypes.string.isRequired,
  setView: PropTypes.func.isRequired,
};

export default Selector;



// WEBPACK FOOTER //
// ./src/pages/SalonLocator/ResultSection/Selector.js